import { useParams } from 'react-router-dom';

import { EventDateModal } from './EventDateModal';

export const EventDatePage = ({ causeId, eventId }: { causeId?: string; eventId?: string }) => {
  const { event_date_uuid } = useParams();
  return (
    <EventDateModal
      opened={true}
      eventDateId={event_date_uuid}
      causeId={causeId}
      eventId={eventId}
    />
  );
};
